import {
  getInstanceSnapshotsAsync,
  handleToggleInstanceRunManualBackupModal,
  selectInstance,
  selectInstanceLoading,
  selectInstanceAutoBackupInfo,
  selectInstanceAutoBackupInfoLoading,
  selectInstanceAutoBackupActionLoading,
  getInstanceAutoBackupInfoAsync,
  disableInstanceAutoBackupAsync,
  enableInstanceAutoBackupAsync,
  deleteInstanceSnapshotAsync,
  selectInstanceSnapshots,
  selectInstanceSnapshotsActionLoading,
  selectInstanceSnapshotsLoading,
} from "../../../../store/instances/instanceSlice";
import PlusIcon from "./../../../../assets/icons/plus.svg?react";
import ArchiveIcon from "./../../../../assets/icons/archive-box.svg?react";
import MoreIcon from "./../../../../assets/icons/more.svg?react";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { InstanceBackupsUrl, InstancesCreateUrl } from "../../../../utils/urls";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useMemo, useState } from "react";
import InstancesBackupModal from "./InstancesBackupModal";
import HighlighterText from "./../../../general/HighlighterText";
import QuestionModal, { DeleteModal } from "../../../modals/QuestionModal";
import { useSearch } from "../../../../providers/SearchProvider";
// import { getInstancesAsync } from "../../../../store/instances/instancesSlice";
import { InstanceSnapshot } from "../../../../types/instance";
import {
  Alert,
  Button,
  Dropdown,
  EmptyState,
  Flex,
  SimpleTable,
  Tag,
  Typography,
} from "djuno-design";

const InstanceBackupsTab = () => {
  const [showEnableBackupsModal, setShowEnableBackupsModal] =
    useState<boolean>(false);

  const [deleteBackup, setDeleteBackup] = useState<InstanceSnapshot | null>(
    null
  );

  const instance = useAppSelector(selectInstance);
  const instanceLloading = useAppSelector(selectInstanceLoading);

  const snapshots = useAppSelector(selectInstanceSnapshots);
  const snapshotsLoading = useAppSelector(selectInstanceSnapshotsLoading);
  const snapshotsActionLoading = useAppSelector(
    selectInstanceSnapshotsActionLoading
  );

  //auto-backup
  const autoBackupInfo = useAppSelector(selectInstanceAutoBackupInfo);
  const autoBackupInfoLoading = useAppSelector(
    selectInstanceAutoBackupInfoLoading
  );
  const autoBackupActionLoading = useAppSelector(
    selectInstanceAutoBackupActionLoading
  );

  const enabledAutoBackup = useMemo(() => {
    return typeof autoBackupInfo === "object" && !!autoBackupInfo?.id;
  }, [autoBackupInfo]);

  const [filteredSnapshots, setFilteredSnapshots] = useState<
    InstanceSnapshot[]
  >([]);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { value: searchValue } = useSearch();

  useEffect(() => {
    if (instance)
      dispatch(
        getInstanceAutoBackupInfoAsync({
          instanceId: instance.id,
          regionName: instance.region,
        })
      );
  }, [dispatch, instance]);

  useEffect(() => {
    if (instance)
      dispatch(getInstanceSnapshotsAsync({ instanceId: instance.id }));
  }, [dispatch, instance]);

  const handleDisableAutoBackup = useCallback(() => {
    if (typeof autoBackupInfo === "object" && autoBackupInfo?.id && instance) {
      dispatch(
        disableInstanceAutoBackupAsync({
          regionName: instance.region,
          backupWorkflowId: autoBackupInfo.id,
          instanceId: instance.id,
        })
      ).then((action) => {
        if (action.type === "instance/auto-backup/disable/fulfilled") {
          dispatch(
            getInstanceAutoBackupInfoAsync({
              instanceId: instance.id,
              regionName: instance.region,
            })
          );
        }
      });
    }
  }, [autoBackupInfo, instance, dispatch]);

  useEffect(() => {
    if (instance) {
      dispatch(getInstanceSnapshotsAsync({ instanceId: instance.id }));
    }
  }, [dispatch, instance]);

  useEffect(() => {
    if (snapshots) {
      const filtered = snapshots.filter((snapshot) =>
        snapshot.name.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredSnapshots(filtered);
    }
  }, [searchValue, snapshots]);

  return (
    <div>
      {instance && (
        <div className="mt-2 flex flex-col gap-4 w-full">
          <Typography.Text className="!text-xs md:!text-sm">
            Backups are automatic copies of youy servers disk.For every server
            there are seven slots fo backups. If all slots are full and an
            additional one is created, then the oldest backup will be deleted.
            We recommend that you power off your server before creating a backup
            to ensure data consistency on the disks. Enabling Backups for your
            server will cost 20% of your server plan per month
          </Typography.Text>
          <div className="flex items-center gap-3">
            <div>
              <Button
                onClick={() => {
                  dispatch(handleToggleInstanceRunManualBackupModal(true));
                }}
              >
                Run Manual Backups
              </Button>
            </div>
            <>
              <Button
                loading={autoBackupActionLoading}
                onClick={() => {
                  if (enabledAutoBackup) {
                    handleDisableAutoBackup();
                  } else {
                    setShowEnableBackupsModal(true);
                  }
                }}
              >
                {enabledAutoBackup
                  ? "Disable Automated Backups"
                  : "Enable Automated Backups"}
              </Button>
            </>
          </div>

          <div className="mt-5 w-full">
            <SimpleTable
              loading={snapshotsLoading || autoBackupInfoLoading}
              containerClassName="min-h-[240px]"
            >
              <SimpleTable.Head>
                <SimpleTable.Row>
                  <SimpleTable.TH lable="Name" />
                  <SimpleTable.TH lable="ID" />
                  <SimpleTable.TH lable="Region" />
                  <SimpleTable.TH lable="Size" />
                  <SimpleTable.TH lable="Creation date" />
                  <SimpleTable.TH lable="Status" />
                  <SimpleTable.TH lable="" />
                </SimpleTable.Row>
              </SimpleTable.Head>
              <SimpleTable.Body>
                {filteredSnapshots.map((snapshot, i) => (
                  <SimpleTable.Row key={i}>
                    <SimpleTable.TD className="cursor-pointer">
                      <div className="flex flex-col gap-1">
                        <HighlighterText
                          searchValue={searchValue}
                          textToHighlight={snapshot.name}
                          className="max-w-[110px] md:max-w-[400px] lg:max-w-[350px] xl:max-w-[400px] truncate"
                        />
                      </div>
                    </SimpleTable.TD>
                    <SimpleTable.TD className="cursor-pointer">
                      <Typography.Text className="!text-xs md:!text-sm whitespace-nowrap">
                        {snapshot.id}
                      </Typography.Text>
                    </SimpleTable.TD>

                    <SimpleTable.TD className="cursor-pointer">
                      <Typography.Text className="!text-xs md:!text-sm whitespace-nowrap">
                        {snapshot.region}
                      </Typography.Text>
                    </SimpleTable.TD>

                    <SimpleTable.TD className="cursor-pointer">
                      <Typography.Text className="!text-xs md:!text-sm whitespace-nowrap">
                        {snapshot.size.toFixed(2)} GiB
                      </Typography.Text>
                    </SimpleTable.TD>

                    <SimpleTable.TD className="cursor-pointer">
                      <Typography.Text className="!text-xs md:!text-sm whitespace-nowrap">
                        {snapshot.creationDate}
                      </Typography.Text>
                    </SimpleTable.TD>

                    <SimpleTable.TD className="cursor-pointer">
                      <Flex>
                        <Tag
                          className="text-xs"
                          color={
                            snapshot.status === "active" ? "success" : "warning"
                          }
                        >
                          {snapshot.status}
                        </Tag>
                      </Flex>
                    </SimpleTable.TD>

                    <SimpleTable.TD className="w-32 gap-1">
                      <div className="h-full w-full inline-flex items-center justify-center gap-1">
                        <div className="w-8 flex justify-center items-center">
                          <Dropdown
                            itemsClassName="!p-0"
                            anchor="bottom end"
                            menu={[
                              {
                                key: "1",
                                label: (
                                  <div className="flex items-center gap-1">
                                    {/* <DetailsIcon className="w-4" /> */}
                                    <PlusIcon className="w-4" />
                                    Create instance
                                  </div>
                                ),
                                onClick: () =>
                                  navigate(
                                    `${InstancesCreateUrl}?instanceBackupId=${
                                      snapshot.id
                                    }&instanceId=${
                                      instance.id
                                    }&returnUrl=${InstanceBackupsUrl(
                                      instance.id
                                    )}`
                                  ),

                                disabled:
                                  instanceLloading ||
                                  snapshot.status !== "active",
                              },

                              {
                                type: "divider",
                              },
                              {
                                key: "end",
                                label: (
                                  <div className="flex items-center gap-1">
                                    <ArchiveIcon className="w-4" />
                                    Delete
                                  </div>
                                ),
                                danger: true,
                                onClick: (_, close) => {
                                  close();
                                  setDeleteBackup(snapshot);
                                },
                                disabled:
                                  instanceLloading ||
                                  snapshot.status !== "active",
                              },
                            ]}
                          >
                            <div className=" p-2 rounded-md dark:border-dark-2 hover:dark:bg-dark-2 hover:bg-slate-200">
                              <MoreIcon className="w-4 h-4 dark:text-slate-100 text-slate-800" />
                            </div>
                          </Dropdown>
                        </div>
                        {/* <ArrowRightIcon className="w-4 h-4 dark:text-slate-100 text-slate-800 cursor-pointer" /> */}
                      </div>
                    </SimpleTable.TD>
                  </SimpleTable.Row>
                ))}

                {snapshots.length === 0 && (
                  <SimpleTable.Row
                    withoutHoverStyle={true}
                    className="h-[200px]"
                  >
                    <SimpleTable.TD colSpan={7} className="!border-0">
                      <EmptyState text="You have not created any backup yet" />
                    </SimpleTable.TD>
                  </SimpleTable.Row>
                )}
              </SimpleTable.Body>
            </SimpleTable>
          </div>
        </div>
      )}

      <InstancesBackupModal />

      <QuestionModal
        title="Enable Backups"
        description={
          <div className="flex flex-col">
            <Typography.Text className="!text-xs md:!text-sm mb-1 mt-5">
              Enabling backups will be recurringly billed,for 20 % per month of
              your current plan.Our terms and conditions apply.
            </Typography.Text>
            <Alert uiType="warning" className="text-xs mb-3" showIcon>
              Volumes are not included in backups
            </Alert>
          </div>
        }
        isOpen={showEnableBackupsModal}
        onClose={() => {
          setShowEnableBackupsModal(false);
        }}
        onConfirm={() => {
          if (instance) {
            dispatch(
              enableInstanceAutoBackupAsync({
                regionName: instance?.region,
                data: {
                  instanceId: instance.id,
                  name: instance.name,
                  cron: "24 1 * * *",
                },
              })
            ).then((action) => {
              if (action.type === "instance/auto-backup/enable/fulfilled") {
                dispatch(
                  getInstanceAutoBackupInfoAsync({
                    instanceId: instance.id,
                    regionName: instance.region,
                  })
                );
              }
              setShowEnableBackupsModal(false);
            });
            // dispatch(
            //   getInstanceSnapshotAsync({ instanceId: instance.id })
            // ).then((action: any) => {
            //   if (
            //     action.type === "instances/snapshot/fulfilled" &&
            //     action.payload
            //   ) {
            //     setFilteredSnapshots(action.payload.snapshots);
            //   }
            // });
          }
        }}
        confirmButtonType="primary"
        confirmButtonText="Enable & Buy now"
        confirmButtonClassName="confirm-button-fit-content"
        loading={autoBackupActionLoading}
      />

      <DeleteModal
        title="Delete a Backup"
        description={
          <div className="flex flex-col">
            <Typography.Text className="!text-xs md:!text-sm  mb-5">
              Permanently delete
              {deleteBackup?.name} {deleteBackup?.creationDate}
            </Typography.Text>
            <Alert
              uiType="warning"
              className="text-xs mb-3"
              // icon={<ErrorIcon className="w-5 mr-1 aspect-square" />}
            >
              All of the data on this instance backup will be lost.
            </Alert>
          </div>
        }
        isOpen={deleteBackup !== null}
        onClose={() => setDeleteBackup(null)}
        confirmButtonText="Confirm"
        confirmButtonType="danger"
        confirmButtonClassName="w-full"
        onConfirm={async () => {
          if (!deleteBackup || !instance) return;

          const action = await dispatch(
            deleteInstanceSnapshotAsync({
              instanceId: instance.id,
              imageId: deleteBackup.id,
            })
          );

          if (action.type === "instance/snapshot/delete/fulfilled") {
            await dispatch(
              getInstanceSnapshotsAsync({ instanceId: instance.id })
            );
            setDeleteBackup(null);
          }
        }}
        loading={snapshotsLoading || snapshotsActionLoading}
        confirmString={deleteBackup?.name}
      />
    </div>
  );
};

export default InstanceBackupsTab;
